export enum EnumUploadCargaTipo {
    PRODUTO = 1,
    PESSOA = 2
}